import { Box, Input, ScrollArea, UnstyledButton } from '@tf/ui';
import React from 'react';

export const Menu: React.FC<{
	items: string[];
	selectedItem: string;
	onSelect: (item: string) => void;
}> = ({ items, selectedItem, onSelect }) => {
	// isSelected={item === selectedItem}

	const [searchTerm, setSearchTerm] = React.useState('');

	const filteredItems =
		searchTerm.length > 0 ? items.filter((item) => item.toLowerCase().includes(searchTerm.toLowerCase())) : items;

	return (
		<Box
			sx={{
				flex: '0 0 320px',
				display: 'flex',
				flexDirection: 'column',
				width: '320px',
				maxHeight: '90vh',
				background: '#FFF',
				border: '1px solid #DDD',
				borderRadius: '4px',
			}}
		>
			<Box p="8px">
				<Input placeholder="Search" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
			</Box>

			{filteredItems.length === 0 ? <Box p="8px">Nothing found</Box> : null}

			<ScrollArea type="never" scrollbars="y">
				{filteredItems.map((item) => (
					<UnstyledButton
						key={item}
						sx={{
							display: 'block',
							width: '100%',
							padding: '4px 8px',
							fontWeight: item === selectedItem ? 'bold' : 'normal',
							borderBottom: '1px solid #EEE',
						}}
						title={item}
						onClick={() => onSelect(item)}
					>
						{item}
					</UnstyledButton>
				))}
			</ScrollArea>
		</Box>
	);
};
